function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 500 500",
    className: "svg",
    preserveAspectRatio: "xMidYMid ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M378.481,357.746c-59.728-21.762-78.817-40.118-78.817-79.432c0-23.607,18.238-15.896,26.257-59.113 c3.312-17.906,19.42-0.284,22.495-41.209c0-16.295-8.775-20.364-8.775-20.364s4.447-24.125,6.197-42.699 C348.015,91.799,332.474,32,249.614,32c-82.888,0-98.426,59.799-96.253,82.93c1.75,18.575,6.218,42.699,6.218,42.699 s-8.8,4.069-8.8,20.364c3.078,40.925,19.187,23.303,22.499,41.209c8.016,43.217,26.256,35.505,26.256,59.113 c0,39.313-19.086,57.67-78.796,79.432c-59.914,21.833-98.826,44.068-98.826,59.255V468h455.373v-50.999 C477.286,401.814,438.374,379.579,378.481,357.746L378.481,357.746z",
    id: "path-0",
    fill: "#eaeaea",
    style: {
      position: "relative"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.18b6dc63a34400690ea2577a9d5218d8.svg";
export { ForwardRef as ReactComponent };